var scope_0 = require('/vercel/workpath0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ca433d2d97d985df5e123f6556f1ae8.js').default;export default
        Object.assign({}, scope_0 )
    